function getTokenFromLocalStorage() {
  try {
    const token = localStorage.getItem("token");
    if (token) {
      console.log("user token : ", token);
      return token;
    } else {
      return null;
    }
  } catch (err) {
    console.error("error getting token : ", err);
  }
}

function getCifNumberFromLocalStorage() {
  try {
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
      console.log("user info : ", JSON.parse(userInfo).cifNumber);
      return JSON.parse(userInfo).cifNumber;
    } else {
      return null;
    }
  } catch (err) {
    console.error("error getting cif number : ", err);
  }
}

module.exports = {
  getTokenFromLocalStorage,
  getCifNumberFromLocalStorage,
};
